import AuthenticationActions, {
  AuthenticationSelectors
} from "../../Redux/AuthenticationRedux";
import React, { Component } from "react";
import styles, { MainContainer } from "./styles";

import { Fonts } from "../../Themes/Fonts";
import ForgottenPasswordForm from "../../Forms/ForgottenPasswordForm";
import SweetAlert from "react-bootstrap-sweetalert";
import { compose } from "redux";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";

const RenderAlert = props => {
  return (
    <SweetAlert
      success
      confirmBtnText="Close"
      confirmBtnBsStyle="default"
      cancelBtnBsStyle="default"
      title="Reset link sent"
      onConfirm={props.resetClose}
    >
      Check your email for the reset link
    </SweetAlert>
  );
};

class ForgottenPasswordScreen extends Component {
  state = {
    showAlert: false,
    submissionSuccess: false,
    submissionError: null,
    fetching: false
  };

  resetClose = () => {
    this.setState({
      showAlert: false
    });
  };

  handleSubmit = ({ resetEmail }) => {
    // const { resetLink } = this.props;

    this.setState({
      fetching: true
    });

    // const resolve = {
    //   onSuccess: () =>
    //     this.setState({
    //       submissionSuccess: true,
    //       submissionError: null,
    //       fetching: false
    //     }),
    //   onFailure: e =>
    //     this.setState({
    //       submissionSuccess: false,
    //       submissionError: e,
    //       fetching: false
    //     })
    // };

    return;

    // resetLink({
    //   values: resetEmail,
    //   submissionSuccess: () =>
    //     this.setState({ submissionSuccess: true, submissionError: null }),
    //   submissionError: error =>
    //     this.setState({ submissionError: error, submissionSuccess: true })
    // });
  };

  render() {
    const { showAlert, submissionError, submissionSuccess, fetching } = this.state;
    const { classes } = this.props;
    return (
      <MainContainer>
        <div className={classes.container}>
          {showAlert ? <RenderAlert resetClose={this.resetClose} /> : null}
          <div
            className={`${submissionError &&
              classes.failureContainer}`}
          >
            <h1 style={Fonts.headerFont}>Forgotten Password?</h1>
            <ForgottenPasswordForm
              handleSubmit={this.handleSubmit}
              fetching={fetching}
              success={submissionSuccess}
              error={submissionError}
            />
          </div>
        </div>
      </MainContainer>
    );
  }
}

const mapStateToProps = state => {
  return {
    action: AuthenticationSelectors.getAction(state),
    fetching: AuthenticationSelectors.getFetching(state),
    error: AuthenticationSelectors.getError(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    resetLink: data => dispatch(AuthenticationActions.resetLinkRequest(data))
  };
};

const withRedux = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default compose(
  withStyles(styles),
  withRedux
)(ForgottenPasswordScreen);
